import React, { useEffect, useState } from 'react';
import { useCountUp } from 'react-countup';
import { useInView } from 'react-intersection-observer';

const Counter = ({ value, inView }: { value: number; inView?: boolean }) => {
	const { countUp, start } = useCountUp({
		start: 0,
		end: value,
		duration: 1.25,
		prefix: '+',
		separator: '.',
	});
	const [ren, setRen] = useState(false);

	useEffect(() => {
		if (inView && !ren) {
			setRen(true);
			start();
		}
		// eslint-disable-next-line
	}, [inView]);

	return <span>{countUp}</span>;
};

export const DadosHistoricos = () => {
	const { ref, inView } = useInView({
		threshold: 0,
	});

	return (
		<div
			className="row justify-content-around status-section text-white py-4"
			ref={ref}
		>
			<div className="container d-flex justify-content-around">
				<div className="col-6 col-md-4 d-flex flex-column align-items-center">
					<h1 className={'text-center font-weight-bold'}>
						{' '}
						<Counter value={800000} inView={inView} />{' '}
					</h1>
					<h3 className={'h3 text-center'}>
						Pacientes e análises de dados
					</h3>
				</div>
				<div className="col-6 col-md-4 d-flex flex-column align-items-center">
					<h1 className={'text-center font-weight-bold'}>
						<Counter value={10000} inView={inView} />
					</h1>
					<h3 className={'h3 text-center'}>Profissionais de Saúde</h3>
				</div>
			</div>
		</div>
	);
};
